import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import MuiSwitch from '@material-ui/core/Switch';

import { MyTimePicker } from '../FormWidgets/DatePicker.js';
import { multiIOHwTypeMappping } from '../Constants/constants.js';

export function OverwrIOSelect({ select, type, onChange, controller, parent, ...other }) {
  const resolvedType = typeof type === 'number' ? multiIOHwTypeMappping[type] : type;

  return (
    <React.Fragment>
      <Typography gutterBottom>
        <MuiSwitch
          checked={
            resolvedType === 'digital_out'
              ? select === 1
              : resolvedType === 'analog_out'
                ? select === 2
                : undefined
          }
          onChange={onChange}
          disabled={other.disabled}
          color="primary"
        />
      </Typography>
    </React.Fragment>
  );
}

export function OverwrIOTimeout({ timeout, onChange, controller, parent, ...other }) {
  let { t } = useTranslation();

  const handleChange = (value, event) => {
    onChange(event ?? null, value);
  };

  return (
    <React.Fragment>
      <MyTimePicker
        value={timeout}
        seconds={true}
        nonZero={true}
        name="timeout"
        onChange={handleChange}
        initialFocusedDate={new Date('1995-07-21T00:30:00')}
        placeholder={t('no_overwr_timeout')}
        disabled={other.disabled}
      />
    </React.Fragment>
  );
}
